import { format } from 'date-fns';
import type { FunctionComponent, PropsWithChildren } from 'react';

import { useApplicationContext } from '~/shared/context/use-application-context';

import { LanguageSelect } from '../../common/LanguageSelect';

const LegacyOnboardingFooterLogoutButton: FunctionComponent = () => {
    const { actions, applicationState, translate } = useApplicationContext();

    if (!applicationState.userIsLoggedIn) {
        return null;
    }

    return (
        <button
            className="cursor-pointer border-0 bg-transparent px-s py-xs text-body-s font-medium text-gray-700"
            type="button"
            onClick={actions.logout}
        >
            {translate('common.logout')}
        </button>
    );
};

const LegacyOnboardingFooter: FunctionComponent = () => {
    const { translate } = useApplicationContext();

    return (
        <footer className="flex h-[56px] flex-nowrap items-center justify-between border-gray-200 border-t bg-white-200 px-4xl">
            <LanguageSelect isUnderlineDisabled={true} />
            <p className="m-0 text-sm text-gray-700">{`© ${format(new Date(), 'yyyy')} ${translate('common.brand')}`}</p>
            <LegacyOnboardingFooterLogoutButton />
        </footer>
    );
};

export const LegacyOnboardingContainer: FunctionComponent<PropsWithChildren> = ({ children }) => {
    const {
        applicationState: { customization },
        translate,
    } = useApplicationContext();
    const onboardingImageUrl = customization
        .get('uiConfiguration')
        .get('assets')
        .get('onboardingImageUrl')
        .mapOr('', ({ href }) => href);

    return (
        <div className="flex h-full w-full flex-nowrap">
            <div className="relative h-screen flex-1">
                <div
                    className="sticky top-0 h-screen bg-cover bg-center"
                    style={{ backgroundImage: `url(${onboardingImageUrl})` }}
                >
                    <div className="absolute bottom-[64px] left-[80px] max-w-[40rem]">
                        <p className="m-0 text-[100px] font-bold leading-[0.95] text-white-200 lg:text-[120px]">
                            {translate('pages.onboarding.headline')}
                        </p>
                    </div>
                </div>
            </div>
            <div className="flex min-h-screen flex-1 flex-col">
                <main className="flex flex-1 items-center justify-center">{children}</main>
                <LegacyOnboardingFooter />
            </div>
        </div>
    );
};
